import { ApiResult, CrudService, Meta } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProdutoIdentificacaoVersaoEntity } from '@catalogo/models';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root', })
export class ProdutoVersaoCodigoIdentificacaoDataService extends CrudService<ProdutoIdentificacaoVersaoEntity> {

  protected url: string;

  private urlReplace: string;

  constructor(
    @Inject(OPERACAO_API_URL) public urlBase: string,
    @Inject(HttpClient) protected httpClient: HttpClient
  ) {
    super(urlBase, httpClient);
    this.urlReplace = `${urlBase}/v1/produto/<parent>/ProdutoIdentificacaoVersao`;
  }

  public withParentId(id) {
    this.url = this.urlReplace.replace('<parent>', id);
    return this;
  }

  public getCodigoIdentificacaoVersao(id: string, versaoId: string, meta: Meta) {
    this.url = this.urlReplace.replace('<parent>', id);
    return this.getWithQueryBase<ApiResult<ProdutoIdentificacaoVersaoEntity[]>>(`${this.url}/${versaoId}`, meta);
  }

}
